import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fixDecimal'
})
export class FixDecimalPipe implements PipeTransform {
    transform(value: number, noOfDec: number = 2): number {
        return value ? parseFloat(value.toFixed(noOfDec)) : 0;
    }
}
